import React from 'react';
import { NumberInput } from 'react-admin';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { PARENT_SETTINGS_FIELD } from '../constants';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = { source: string; inheritedSettings: any };

export const BaseMarginPercentW2LocalInput = ({ source, inheritedSettings }: Props) => {
  const { getValues } = useFormContext();
  const { isControlled } = useRateControllerContext();
  const parentSettings = getValues(PARENT_SETTINGS_FIELD);
  const parentSettingsHash = new RateSettingsDisplayHelper({ settings: parentSettings });
  const parentLocalW2Settings = parentSettingsHash.getSettingsForClassification('w2.local');

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <NumberInput
        source={`${source}.base_margin_percent_w2`}
        label="Base Margin Percent W2"
        disabled={!isControlled('baseMargin')}
        sx={{ flex: 1 }}
        helperText={String(
          getInheritedValue(inheritedSettings, 'base_margin_percent_w2', parentLocalW2Settings) ||
            '',
        )}
      />
      <RateFieldCheckbox code="baseMargin" label="Admin controls Base Margin" />
    </Box>
  );
};
